// aggregate=, item

import ReportObject, {
    View as ReportObjectView,
    Text as ReportObjectText,
    Br as ReportObjectBr
} from "./ReportObject";
import {
    pdf,
    Page,
    Image,
    Link,
    Font,
    Text,
    View,
    Document,
    StyleSheet,
    PDFDownloadLink,
    PDFViewer,
    BlobProvider,
  } from '@react-pdf/renderer';

import {
    Table,
    TableHeader,
    TableCell,
    TableBody,
    DataTableCell,
} from '@david.kucsai/react-pdf-table';

import OverviewData from './OverviewData';
import { formatCurrency } from "@utils/numbers";

const PdfGroupedOverviewStatDetail = ({aggregates, result, pdf, pdfStyles}) => {
    // console.log(aggregates);
    // console.log(result);

    const infoForStat = (communityAggregate) => {
        let total = -9999;

        if(typeof communityAggregate === 'number') {
            total = communityAggregate;
        } else if(typeof communityAggregate === 'object') {
            if(Array.isArray(communityAggregate)) {
                total = communityAggregate.length;
            } else if(communityAggregate.hasOwnProperty('rent')) {
                total = communityAggregate.rent;
            } else if(communityAggregate.hasOwnProperty('total')) {
                total = communityAggregate.total;
            } else if(communityAggregate.hasOwnProperty('occupancy_rate')) {
                total = communityAggregate.occupancy_rate*100;
                total = total.toFixed(2)+'%';
            } else if(!communityAggregate.hasOwnProperty('in')) { // ignore in/out since it's handled below
                //
            } else {
                console.warn(communityAggregate);
            }
        }

        // todo: include the # along with the total
        if(['sold_properties', 'public_investments', 'public_improvements', 'improved_properties', 'assessed_market_value', 'grants_received'].indexOf(communityAggregate) !== -1) {
            total = formatCurrency(total);
        }

        return total;
    }

    /*
    // use this code for splitting into two arrays
    let aggregateTableCells = [];
    for(const aggregate of aggregates) {
        if(aggregate.value.indexOf('_by_type') !== -1) continue;
        // console.log(aggregate);
        //label/value
        aggregateTableCells.push({
            label: aggregate.label,
            // value: infoForStat(result.aggregates[aggregate.value])
            value: <OverviewData type={aggregate.value} data={result.aggregates[aggregate.value]} pdf={true} />,
        });
    }

    // console.log(aggregateTableCells);
    const half = Math.ceil(aggregateTableCells.length / 2);
    const firstHalf = aggregateTableCells;//aggregateTableCells.slice(0, half);
    const secondHalf = [];//aggregateTableCells.slice(-half);
    */

    let aggregateTableCells = [];
    let i = 1;
    let currentRow = {};
    for(const aggregate of aggregates) {
        if(aggregate.value.indexOf('_by_type') !== -1) continue;
        // console.log(aggregate);
        //label/value

        // skip aggregates we aren't reporting on
        if(!result.aggregates.hasOwnProperty(aggregate.value)) {
            continue;
        }

        currentRow[`label${i}`] = aggregate.label;
        currentRow[`value${i}`] = <OverviewData type={aggregate.value} data={result.aggregates[aggregate.value]} pdf={true} />;
        i++;

        // check if it should break or is the last item to display and wouldn't otherwise break
        if(i === 3 || aggregates.indexOf(aggregate) === aggregates.length - 1) {
            aggregateTableCells.push({...currentRow});
            currentRow = {};
            i = 1;
        }

        /*
        aggregateTableCells.push({
            label: aggregate.label,
            // value: infoForStat(result.aggregates[aggregate.value])
            value: <OverviewData type={aggregate.value} data={result.aggregates[aggregate.value]} pdf={true} />,
        });
        */
    }
    const firstHalf = aggregateTableCells;
    const secondHalf = [];

    return (
        <View style={[pdfStyles.horizontalGrid, /*{display: 'flex'}*/]}>
            <View style={[pdfStyles.half, /*{flex: 1, width: '48%'}*/]}>
              {firstHalf.length > 0 && (
                <View>
                  <Table
                    data={firstHalf}
                  >
                    <TableBody
                        includeTopBorder={false}
                        includeRightBorder={false}
                        includeBottomBorder={false}
                        includeLeftBorder={false}
                        evenRowColor="white"
                        oddRowColor="#E1E1E1"
                    >
                    {/* <OverviewData type={aggregate.value} data={aggregateMasterOverview[aggregate.value]} pdf /> */}
                        <DataTableCell style={pdfStyles.smallTableCell} getContent={(r) => <Text style={[pdfStyles.tableCellHeader, {fontSize: 8}]}>{r.label1}</Text>}/>
                        <DataTableCell style={pdfStyles.smallTableCell} getContent={(r) => <View style={{fontSize: 8}}>{r.value1}</View>}/>
                        <DataTableCell weighting={.1} style={pdfStyles.smallTableCell} getContent={(r) => null}/>
                        <DataTableCell style={pdfStyles.smallTableCell} getContent={(r) => <Text style={[pdfStyles.tableCellHeader, {fontSize: 8}]}>{r.label2}</Text>}/>
                        <DataTableCell style={pdfStyles.smallTableCell} getContent={(r) => <View style={{fontSize: 8}}>{r.value2}</View>}/>
                    </TableBody>
                  </Table>
              </View>
              )}
            </View>
            <View style={[pdfStyles.half, /*{flex: 1, width: '48%', marginLeft: '2%'}*/]}>
            {secondHalf.length > 0 && (
                <View style={{width: '100%'}}>
                  <Table
                    data={secondHalf}
                  >
                    <TableBody
                        includeTopBorder={false}
                        includeRightBorder={false}
                        includeBottomBorder={false}
                        includeLeftBorder={false}
                        evenRowColor="white"
                        oddRowColor="#E1E1E1"
                    >
                    {/* <OverviewData type={aggregate.value} data={aggregateMasterOverview[aggregate.value]} pdf /> */}
                        <DataTableCell weighting={.75} style={pdfStyles.smallTableCell} getContent={(r) => <Text style={[pdfStyles.tableCellHeader, {fontSize: 8}]}>{r.label}</Text>}/>
                        <DataTableCell style={pdfStyles.smallTableCell} getContent={(r) => <View style={{fontSize: 8}}>{r.value}</View>}/>
                    </TableBody>
                  </Table>
              </View>
              )}
            </View>
          </View>
    );
}

const GroupedOverviewStatDetail = ({aggregate, result, communities, pdf, pdfStyles}) => {
    const getGroupedInfoForStat = (communityName, communityAggregate) => {
        let total = -9999;

        if(typeof communityAggregate === 'number') {
            total = communityAggregate;
        } else if(typeof communityAggregate === 'object') {
            if(Array.isArray(communityAggregate)) {
                total = communityAggregate.length;
            } else if(communityAggregate.hasOwnProperty('rent')) {
                total = communityAggregate.rent;
            } else if(communityAggregate.hasOwnProperty('total')) {
                total = communityAggregate.total;
            } else if(communityAggregate.hasOwnProperty('occupancy_rate')) {
                total = communityAggregate.occupancy_rate*100;
                total = total.toFixed(2)+'%';
            } else if(typeof parseInt(Object.keys(communityAggregate)?.[0]) === 'number') {
                total = Object.keys(communityAggregate).length; // this handles laravel collection objects grouped by ID
            } else {
                console.warn(communityAggregate);
            }
        }

        /*
                    } else if(communityAggregate.hasOwnProperty('occupancy_rate')) {
                total = communityAggregate.occupancy_rate*100;
                total = total.toFixed(2)+'%';
        // format %
        if(['occupancy_rate'].indexOf(aggregate.value) !== -1) {
            total = total.toFixed(2)+'%';
        }
        */
        // todo: include the # along with the total
        if(['sold_properties', 'public_investments', 'public_improvements', 'improved_properties', 'assessed_market_value', 'grants_received'].indexOf(aggregate.value) !== -1) {
            total = formatCurrency(total);
        }

        if(aggregate.value === 'staff_volunteer_hours') {
            total = (<ReportObjectView pdf={pdf}>
                <ReportObjectText pdf={pdf}>Staff: {communityAggregate.staff}</ReportObjectText>
                <ReportObjectBr/>
                <ReportObjectText pdf={pdf}>Volunteer: {communityAggregate.volunteer}</ReportObjectText>
            </ReportObjectView>);
        }

        return {
            name: communities[communityName],
            total: total,
        };
    }

    let item = [];

    if(aggregate.value === 'businesses_relocated') {
        item = {
            in: [],
            out: [],
        };

        for(const communityName in result) {
            if(communityName === 'options') continue;
            const communityAggregate = result[communityName].aggregates[aggregate.value];
            item.in.push(getGroupedInfoForStat(communityName, communityAggregate.in));
            item.out.push(getGroupedInfoForStat(communityName, communityAggregate.out));
        }

        return (<>
            <ReportObject pdf={pdf} pdfStyles={pdfStyles} aggregate={{label: `${aggregate.label} In`, value: 'grouped_statistic'}} item={item.in}/>
            <ReportObject pdf={pdf} pdfStyles={pdfStyles} aggregate={{label: `${aggregate.label} Out`, value: 'grouped_statistic'}} item={item.out}/>
        </>);
    }

    if(aggregate.value === 'total_residential_units' || aggregate.value === 'total_commercial_units') {
        item = {
            units: [],
            properties: [],
        };

        for(const communityName in result) {
            if(communityName === 'options') continue;
            const communityAggregate = result[communityName].aggregates[aggregate.value];
            item.units.push(getGroupedInfoForStat(communityName, communityAggregate.properties_with_units));
            item.properties.push(getGroupedInfoForStat(communityName, communityAggregate.properties_without_units));
        }

        return (<>
            <ReportObject pdf={pdf} pdfStyles={pdfStyles} aggregate={{label: `${aggregate.label} (Properties With Unit Info)`, value: 'grouped_statistic'}} item={item.units}/>
            <ReportObject pdf={pdf} pdfStyles={pdfStyles} aggregate={{label: `${aggregate.label} (Properties Without Unit Info)`, value: 'grouped_statistic'}} item={item.properties}/>
        </>);
    }

    for(const communityName in result) {
        if(communityName === 'options') continue;
        const communityAggregate = result[communityName].aggregates[aggregate.value];
        item.push(getGroupedInfoForStat(communityName, communityAggregate));
    }

    return (
        <ReportObject pdf={pdf} pdfStyles={pdfStyles} aggregate={{label: aggregate.label, value: 'grouped_statistic'}} item={item}/>
    );
}

const OverviewStatDetail = ({aggregate, item, result, communities}) => {
    if(result && !item) {
        return <GroupedOverviewStatDetail aggregate={aggregate} result={result} communities={communities} />
    }

    if(aggregate.value === 'businesses_relocated') {
        return (<>
            <ReportObject aggregate={{label: `${aggregate.label} In`, value: `${aggregate.value}_in`}} item={item.in}/>
            <ReportObject aggregate={{label: `${aggregate.label} Out`, value: `${aggregate.value}_out`}} item={item.out}/>
        </>);
    }

    if(aggregate.value === 'total_residential_units' || aggregate.value === 'total_commercial_units') {
        return (<>
            <ReportObject aggregate={{label: `${aggregate.label} (Properties With Unit Info)`, value: `${aggregate.value}_units`}} item={item}/>
            <ReportObject aggregate={{label: `${aggregate.label} (Properties Without Unit Info)`, value: `${aggregate.value}_properties`}} item={item}/>
        </>);
    }

    return (
        <ReportObject aggregate={aggregate} item={item}/>
    );
}

export {GroupedOverviewStatDetail, PdfGroupedOverviewStatDetail};

export default OverviewStatDetail;
